// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class TreatmentAPI extends MainAPI {
	/**
	 * @return {object} treatment list
	 * @param {*} treatmentDetails - Contains pagination data
	 * @param petId - Pet's ID
	 */
	async getTreatments(petId, treatmentDetails) {
		return API.get(`${ENDPOINTS.GET_TREATMENTS}/${petId}?${queryString.stringify(treatmentDetails)}`);
	}

	/**
	 * @param {*} treatmentDetails - contains Bundle ID and Date
	 * @param petId - Pet's ID
	 */
	async postTreatments(petId, treatmentDetails) {
		return API.post(`${ENDPOINTS.POST_TREATMENTS}/${petId}`, treatmentDetails);
	}

	/**
	 * @return {object} treatment details
	 * @param {*} treatmentId
	 * @param dateApplied
	 */
	async putTreatment(treatmentId, dateApplied) {
		return API.put(`${ENDPOINTS.PUT_TREATMENT}/${treatmentId}/apply`, dateApplied);
	}

	/**
	 * @return {object} treatment details
	 * @param {*} treatmentId
	 */
	async deleteTreatment(treatmentId) {
		return API.delete(`${ENDPOINTS.DELETE_TREATMENT}/${treatmentId}/discontinue`);
	}

	/**
	 * @return {object} bundle details
	 * @param {*} bundleOptions - Options for specific filtering
	 */
	async getBundles(bundleOptions) {
		return API.get(`${ENDPOINTS.GET_BUNDLES}?${queryString.stringify(bundleOptions)}`);
	}

	/**
	 * @return {object} Brands
	 * @param {*} productType - product name.
	 * */
	async getBrands(productType) {
		return API.get(`${ENDPOINTS.GET_BRANDS}?${queryString.stringify(productType)}`);
	}

	/**
	 * @return {object} treatment overdue count
	 * @param {*} petID - active pet id.
	 * */
	async getTreatmentOverdueCount(petId) {
		return API.get(`${ENDPOINTS.GET_TREATMENTS}/${petId}/due-today/count`);
    }
    
     /**
	 * @return {object} Apply treatment
	 * @param {*} treatmentScheduleId - schedule id
	 * */
	async getTreatmentSchedule(treatmentScheduleId) {
		return API.get(`${ENDPOINTS.GET_TREATMENT_SCHEDULE}/${treatmentScheduleId}`);
	}
}

export default new TreatmentAPI();